// extracted by mini-css-extract-plugin
module.exports = {"Button":"css-modules_Button__MxUv5","suffix":"css-modules_suffix__9j1a3"};